import { z } from "zod";
import { DAY_STATUSES } from "./status.js";
export const isoDateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "expected YYYY-MM-DD");
export const dayStatusSchema = z.enum(DAY_STATUSES);
export const loginSchema = z.object({
    email: z.string().email().max(200),
    password: z.string().min(1).max(200),
});
export const dayEntrySchema = z.object({
    date: isoDateSchema,
    status: dayStatusSchema,
    note: z.string().max(500).optional(),
    clientId: z.string().max(40).optional(),
    // Extra clients billed on the same date, beyond the primary clientId above.
    // Each is a full or half day; a date can total more than one billed day.
    allocations: z
        .array(z.object({ clientId: z.string().max(40), status: z.enum(["full", "half"]) }))
        .max(20)
        .optional(),
});
// An invoice deep link is rendered as a clickable <a href>, so it must be an
// http(s) URL — never javascript:/data:, which would be a stored-XSS vector.
export const invoiceUrlSchema = z
    .string()
    .trim()
    .max(500)
    .url()
    .refine((u) => /^https?:\/\//i.test(u), "must be an http(s) URL");
export const paymentSchema = z.object({
    expectedCents: z.number().int().positive(),
    receivedCents: z.number().int().positive().optional(),
    expectedDate: isoDateSchema.optional(),
    receivedDate: isoDateSchema.optional(),
    period: z.string().max(20).optional(),
    note: z.string().max(500).optional(),
    invoiceRef: z.string().trim().max(50).optional(),
    invoiceUrl: invoiceUrlSchema.optional(),
    clientId: z.string().max(40).optional(),
});
//# sourceMappingURL=schemas.js.map